module.exports = __webpack_public_path__ + "static/img/deviceFaultBg.76627cbf.png";